import { render, staticRenderFns } from "./wr3.vue?vue&type=template&id=5319f038&scoped=true&"
import script from "./wr3.vue?vue&type=script&lang=js&"
export * from "./wr3.vue?vue&type=script&lang=js&"
import style0 from "./wr3.vue?vue&type=style&index=0&id=5319f038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5319f038",
  null
  
)

export default component.exports